import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Loading } from "@/layouts/components";
import { RoutesList } from "@/router/routesList";
import { useGetScheduleByIdQuery, useUpdateScheduleMutation, } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { ScheduleForm } from "./components/ScheduleForm";
import { convertToUpdateScheduleDto } from "./mappers/convertFromViewModel";
import { convertToScheduleViewModel } from "./mappers/convertToViewModel";
/** Редактирование расписания */
export var ScheduleUpdatePage = function () {
    var _a = useParams(), placeId = _a.placeId, scheduleId = _a.scheduleId;
    var scheduleGetState = useGetScheduleByIdQuery({
        id: scheduleId,
    });
    var _b = useUpdateScheduleMutation(), updateScheduleAction = _b[0], updateScheduleState = _b[1];
    var saveFormHandler = function (data) {
        try {
            updateScheduleAction({
                id: scheduleId,
                updateScheduleDto: convertToUpdateScheduleDto(data),
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (updateScheduleState.isSuccess) {
            navigate(RoutesList.Place.getPlaceSchedules(placeId));
        }
    }, [updateScheduleState.isSuccess]);
    useSetPageData({
        title: "Изменение шаблона",
        backLink: RoutesList.Place.getPlaceScheduleTemplates(placeId),
    });
    return (_jsxs("div", { children: [_jsx(Loading, { isActive: scheduleGetState.isFetching, loadingKey: "calendarSchedule" }), scheduleGetState.isSuccess && (_jsx(ScheduleForm, { data: convertToScheduleViewModel(scheduleGetState.data), mode: "update", onSave: saveFormHandler }))] }));
};
